import { Suspense, lazy, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import 'dayjs/locale/de';
import 'swiper/css';

import '@bluecodecom/fonts';

import { LoaderProvider } from '@bluecodecom/loader';

import { ThemeProvider } from '@bluecodecom/theme';

import { nativeService } from '@bluecodecom/native';

import './i18n';

const App = lazy(() => import('./app'));

const Main = () => {
  useEffect(() => {
    nativeService.allowResumeMiniApp();
  }, []);

  return (
    <LoaderProvider>
      <ThemeProvider observe>
        <BrowserRouter>
          <Suspense>
            <App />
          </Suspense>
        </BrowserRouter>
      </ThemeProvider>
    </LoaderProvider>
  );
};

createRoot(document.getElementById('root') as HTMLElement).render(<Main />);
